export default __webpack_public_path__ + "static/media/Fine.6aff875a.png";